import { createSubscribableMutator } from '@famly/vet_apollo-utils_create-subscribable-mutator';
import { UpdateHolidayAllowanceMutation } from './update-holiday-allowance.mutation';
export const { useSubscribableMutation: useUpdateHolidayAllowance, useSubscribeMutationResult: useUpdateHolidayAllowanceResult, } = createSubscribableMutator(UpdateHolidayAllowanceMutation);
